<button *ngIf="!!text" mat-raised-button color="accent" (click)="loadWidget()" [disabled]="!hasScriptAppended">
  {{ text }}
</button>
